import { ChainProvider, ContractFacade } from "./abstact/ContractFacade";
import { LPXCtrlPoolMngr_v1ABI } from "./abi/LPXCtrlPoolMngr_v1ABI";

export class LPXCtrlPoolMngrContract extends ContractFacade
{
    constructor(address:string, provider:ChainProvider)
    {
        super(address, LPXCtrlPoolMngr_v1ABI.GetABI(), provider);
    }

    async managerSetPoolIndexesAsync(poolId:number, ntzIndex:bigint, profitIndex:bigint): Promise<any>
    {
        return await this._send("manager_setPoolIndexes", poolId, ntzIndex, profitIndex);
    }

    async managerSetPoolsFlagAsync(poolIds:number[], flag:number, value:boolean): Promise<any>
    {
        return await this._send("manager_setPoolsFlag", poolIds, flag, value);
    }

    async managerSetPoolsAccessFlagAsync(poolIds:number[], flag:number, value:boolean): Promise<any>
    {
        return await this._send("manager_setPoolsAccessFlag", poolIds, flag, value);
    }

    async managerSetPoolImgReservesAsync(poolId:number, fundImgReserve:bigint, anchorImgReserve:bigint): Promise<any>
    {
        return await this._send("manager_setPoolImgReserves", poolId, fundImgReserve, anchorImgReserve);
    }

    async managerScalePoolLiquidityAsync(poolId:number, scale:bigint): Promise<any>
    {
        return await this._send("manager_scalePoolLiquidity", poolId, scale);
    }

    async poolsTimestampsAsync(poolId:number): Promise<bigint>
    {
        const result = await this._call("poolsTimestamps", poolId);
        if (result === undefined) return 0n;
        return BigInt(result);
    }
}
